import React from "react";

import { Activity } from "@packages/client";

import templates from "src/organization/common/components/activities/activityTemplates";

import * as S from "./styles";

type Props = {
  activity: Activity;
};

const ActivityTitle = ({ activity }: Props) => {
  const template = templates[activity.type] || templates.unknown;
  const commits = activity.payload.commits;
  const icon = template.icon;

  return (
    <S.Layout>
      <S.Activity>
        <S.ActivityIcon>{icon}</S.ActivityIcon>
        <S.ActivityTitle>
          {commits ? (
            <>
              <b>{activity.payload.commits[0].sha.slice(0, 7)}</b>&nbsp;-{" "}
              {activity.payload.commits[0].message}
            </>
          ) : (
            template.title({ activity })
          )}
        </S.ActivityTitle>
      </S.Activity>
    </S.Layout>
  );
};

export default ActivityTitle;
